(function ($) {
  Drupal.behaviors.spp_model_grid_v1 = {
    attach: function (context) {
      $('.sppmg__v1', context).once(function () {
        // Global vars
        var isRTL = false;
        var $template = $(this);
        var $body = $('body', context);
        var carousel = $template.find('.js-sppmg__carousel');
        var carouselWrapper = carousel.find('.js-sppmg__carousel--wrapper');
        var innerCarousel = carousel.find('.js-sppmg__carouselInner');
        var closeIcon = carousel.find('.js-sppmg__carousel--hidden img');
        var sppModelGridContents = carousel.siblings('.js-sppmg__content');
        var sppModelGridModalBg = carousel.siblings('.sppmg__modalBg');
        var $tileEl = $template.find('.js-sppmg');
        var chevronVal = carousel.find('.sppmg__carouselNav').length;
        var sdSPP = $body.find('.sd-product-spp')[0];
        var slideTotal;
        var firstSlide;
        var lastSlide;
        var theDirection;
        var counter = 0;
        var marginResetLeft;
        var marginResetRight;
        var counterRight;
        var counterLeft;
        var tileMargin;
        var isAnimating = false;
        var goingLeft = false;
        var goingRight = false;
        var initLoad = false;
        var lastWidth = window.innerWidth;
        var resizeTimerId;
        // Delay (in ms) used to synchronize JS interactions with CSS transitions/animations.
        // 500ms was chosen to roughly match the visual transition duration so animations
        // can complete before new interactions are allowed, without feeling unresponsive.
        var animationDelay = 500;
        var sppModelGridScope = {
          init: function () {
            // Element vars.
            sppModelGridScope.els = {
              sppModelGridWrapper: $template.find('.js-sppmg__grid'),
              sppModelGridAccordionToggle: $template.find('.js-sppmg__accordionToggle'),
              sppModelGridHover: $template.find('.js-sppmg__hovOuter'),
              sppModelGridHoverShop: $template.find('.js-sppmg__hovShop'),
              sppModelGridHoverSold: $template.find('.js-sppmg__hovsoldout'),
              sppModelGridItem: $template.find('.js-sppmg'),
              sppModelGridItemNotInactive: $template.find('.js-sppmg:not(.deactivate,.hide)'),
              sppModelGridFilter: $template.find('.js-sppmg__filter'),
              sppModelGridMainImages: $template.find('.js-sppmg__mainImg'),
              sppModelGridProdTitle: $template.find('.js-sppmg__slideProdTitle'),
              sppModelGridProdSubtitle: $template.find('.js-sppmg__slideProdSubtitle'),
              sppModelGridProdPrice: $template.find('.js-sppmg__slidePrice'),
              sppModelGridSlideBtn: $template.find('.js-sppmg__slideBtmInfo button'),
              sppModelGridSlideDetails: $template.find('.js-sppmg__slideDetails'),
              sppModelGridSlideDetailsInner: $template.find('.js-sppmg__slideDetails span')
            };
            // Data vars.
            sppModelGridScope.config = {
              sppModelGridDataLabel1:
                sppModelGridScope.els.sppModelGridFilter.attr('data-filter-label-1'),
              sppModelGridDataList1: sppModelGridScope.els.sppModelGridFilter
                .attr('data-filter-list-1')
                .match(/[^[\]]+/g),
              sppModelGridDataLabel2:
                sppModelGridScope.els.sppModelGridFilter.attr('data-filter-label-2'),
              sppModelGridDataList2: sppModelGridScope.els.sppModelGridFilter
                .attr('data-filter-list-2')
                .match(/[^[\]]+/g),
              sppModelGridDataTileNums1: sppModelGridScope.els.sppModelGridWrapper
                .attr('data-tile-nums-1')
                .match(/[^[\]]+/g),
              sppModelGridDataTileNums2: sppModelGridScope.els.sppModelGridWrapper
                .attr('data-tile-nums-2')
                .match(/[^[\]]+/g),
              sppModelGridDataShopNow:
                sppModelGridScope.els.sppModelGridWrapper.attr('data-shop-now'),
              sppModelGridDataSoldOut:
                sppModelGridScope.els.sppModelGridWrapper.attr('data-sold-out'),
              sppModelGridDataProd1:
                sppModelGridScope.els.sppModelGridWrapper.attr('data-prod-name-1'),
              sppModelGridDataProd2:
                sppModelGridScope.els.sppModelGridWrapper.attr('data-prod-name-2'),
              sppModelGridDataPrice:
                sppModelGridScope.els.sppModelGridWrapper.attr('data-oz-price'),
              sppModelGridDataBtnCopy:
                sppModelGridScope.els.sppModelGridWrapper.attr('data-button-copy'),
              sppModelGridDataProdId:
                sppModelGridScope.els.sppModelGridWrapper.attr('data-prod-id'),
              sppModelGridDataAccordionEnabled:
                sppModelGridScope.els.sppModelGridWrapper.attr('data-accordion-enabled'),
              sppModelGridDataAccordionRows: parseInt(
                sppModelGridScope.els.sppModelGridWrapper.attr('data-accordion-rows')
              ),
              sppModelGridDataExpandLabel:
                sppModelGridScope.els.sppModelGridWrapper.attr('data-expand-label'),
              sppModelGridDataCollapseLabel:
                sppModelGridScope.els.sppModelGridWrapper.attr('data-collapse-label'),
              sppModelGridDataViewDetails:
                sppModelGridScope.els.sppModelGridWrapper.attr('data-view-details'),
              sppModelGridDataMultiFilterTileNums: {}
            };
            // Func vars.
            sppModelGridScope.func = {
              sppModelGridFilterActive: false,
              sppModelGridFilterSetup: 0,
              sppModelGridProcessedVars: null
            };

            /* Init functionality.
               SPP Grid Items. */
            sppModelGridScope.browserCheck();
            sppModelGridScope.initTileFontSizes(0);
            sppModelGridScope.viewDetailsHandling();
            sppModelGridScope.createFilters();
            sppModelGridScope.createClassFilters();
            sppModelGridScope.createMultiFilterTileNumArray();
            sppModelGridScope.tileFilterCases();
            sppModelGridScope.hideTileFilterCase();
            sppModelGridScope.toggleFilters();

            // SPP Grid Carousel.
            sppModelGridScope.grabSlides();
            sppModelGridScope.updateCarouselSlideContent();
            sppModelGridScope.removeNodeWrappers();
            sppModelGridScope.stripSlideWhitespace();
            sppModelGridScope.widthCalcs();
            sppModelGridScope.addSlideClasses();
            sppModelGridScope.handlePlaceholderSlides();
            sppModelGridScope.checkRTL();
            for (var i = 1; i <= chevronVal; i++) {
              sppModelGridScope.animateCarousel(i);
            }
            sppModelGridScope.openCarouselModal();
            sppModelGridScope.closeCarouselModal();
            sppModelGridScope.closeCarouselModalAnywhere();
            sppModelGridScope.swipeCarousel();
            sppModelGridScope.setListeners();
            sppModelGridScope.updateDeactiveTileWidths();
            sppModelGridScope.isMobile();
            sppModelGridScope.initialiseAccordion();
          },

          isMobile: function () {
            return Number($.cookie('client.isMobile')) || 0;
          },

          updateDeactiveTileWidths: function () {
            var $allTiles = sppModelGridScope.els.sppModelGridWrapper.children();

            $allTiles.removeClass('remove-width');
            if (initLoad === false) {
              $.each($tileEl, function () {
                var $this = $(this);

                if ($this.hasClass('spp_mg_grid_hide') || $this.hasClass('hide')) {
                  $this.parent().addClass('remove-width');
                }
              });
              initLoad = true;
            }
          },

          // Only add the rollover image when asked for.
          setListeners: function () {
            $.each($tileEl, function () {
              var $tile = $(this);
              var $store = $tile.find('.js-hover-img-store');
              // No throttle here as we're only accessing this mouseenter event once.
              $tile.mouseenter(function () {
                if (!$(this).hasClass('image-active')) {
                  $store.find('img').attr('src', $store.data('hover-img-store'));
                  $(this).addClass('image-active');
                }
              });
            });
          },

          // Handle deep linking to the tool.
          deepLink: function () {
            function getParameterByName(name, url) {
              if (!url) {
                url = window.location.href;
              }
              name = name.replace(/[[\]]/g, '\\$&');
              var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
              var results = regex.exec(url);

              if (!results) {
                return null;
              }
              if (!results[2]) {
                return '';
              }

              return decodeURIComponent(results[2].replace(/\+/g, ' '));
            }
            // Handle deep link...?mod=spp_model_grid
            if (getParameterByName('mod') === 'spp_model_grid') {
              $('html, body')
                .delay(1500)
                .animate(
                  {
                    scrollTop: $('#spp_model_grid').offset().top - 100
                  },
                  1500,
                  'easeInOutQuad'
                );
            }
          },

          // Check for devices to handle css differences.
          browserCheck: function () {
            if (
              navigator.userAgent.indexOf('Safari') !== -1 &&
              navigator.userAgent.indexOf('Chrome') === -1
            ) {
              $('body').addClass('isSafari');
            }
            if (navigator.userAgent.match(/iPad/i) !== null) {
              $('body').addClass('isTouch');
            }
          },

          // Builds the filter(s) on the page from the CMS-authored data attributes.
          setupFilters: function (filterList, filterLabel) {
            sppModelGridScope.func.sppModelGridFilterSetup++;
            var listItem;
            var listParent;

            listParent =
              '<ul class="sppmg__filter js-sppmg__filter spp_mg_filter_list_' +
              sppModelGridScope.func.sppModelGridFilterSetup +
              '"></ul>';
            sppModelGridScope.els.sppModelGridFilter.append(listParent);
            $.each(filterList, function (index, val) {
              var string = val.replace(' ', '_');

              if (index === 0) {
                listItem =
                  '<li><span class="sppmg__filterItem js-sppmg__filterItem" data-filter-id="' +
                  string +
                  '">' +
                  val +
                  '</span><span class="divider">|</span></li>';
              } else {
                listItem =
                  '<li><span class="sppmg__filterItem js-sppmg__filterItem" data-filter-id="' +
                  string +
                  '">' +
                  val +
                  '</span><span class="divider">|</span></li>';
              }
              sppModelGridScope.els.sppModelGridFilter
                .find('ul.js-sppmg__filter')
                .eq(sppModelGridScope.func.sppModelGridFilterSetup - 1)
                .append(listItem);
            });
            if (filterLabel) {
              var label =
                '<li class="sppmg__filterLabel"><span>' +
                filterLabel +
                '</span><span class="divider"></span></li>';

              sppModelGridScope.els.sppModelGridFilter
                .find('ul.js-sppmg__filter')
                .eq(sppModelGridScope.func.sppModelGridFilterSetup - 1)
                .find('li')
                .eq(0)
                .before(label);
            }
          },

          /* Need to update the font sizes accoridng to the tile size. This removes any
             class that begins with 'font-size-'. */
          removeFontClass: function () {
            sppModelGridScope.els.sppModelGridItem.removeClass(function (index, className) {
              return (className.match(/\bfont-size-\S+/g) || []).join(' ');
            });
          },

          // This sets the appropriate font-size according to the tile number of the filtered item(s).
          setFontClass: function (index) {
            sppModelGridScope.removeFontClass();
            $.each(sppModelGridScope.els.sppModelGridItem, function () {
              $(this).addClass(
                'font-size-' + sppModelGridScope.config.sppModelGridDataTileNums1[index]
              );
            });
          },

          // Initialise the tile number per row and the font-size on page load.
          initTileFontSizes: function (index) {
            sppModelGridScope.setFontClass(index);
          },

          // Handle the View Details links depending on whether or not it's on an SPP.
          viewDetailsHandling: function () {
            if (
              $('article').hasClass('node-spp-related-content-item-set') ||
              window.top !== window.self
            ) {
              sppModelGridScope.els.sppModelGridSlideDetails.on('click', function (e) {
                var $sppPanel = sdSPP
                  ? $body.find('.sd-product-spp__product-full')
                  : $body.find('.product-full');
                var $shadePicker;
                var $shadeWrapper;
                var $shadeOptions;
                var $stdShadeSelect;
                var skuBase;
                var sku;
                var isMobile =
                  parseInt(Unison.fetch.now().width, 10) === parseInt(Unison.fetch.all().small, 10);

                e.preventDefault();

                if (window.parentIFrame) {
                  return sppModelGridScope.selectParentWindowShade(e);
                }

                if ($sppPanel.length === 0 && isMobile) {
                  $sppPanel = $body.find('.spp-product');
                }
                if ($sppPanel.length > 0) {
                  $shadePicker = $sppPanel.find('.js-product-shade-picker-dropdown');
                  $shadeWrapper = $shadePicker.find('.js-dropdown-input-wrapper');
                  $stdShadeSelect = $sppPanel.find('ul.shade-list li');
                  skuBase = $(this).data('sku-base-id');
                  sku = $(this).data('sku-id');
                  closeIcon.trigger('click');
                  $shadeWrapper.trigger('click');
                  $shadeOptions = $shadeWrapper.siblings('.js-dropdown-options');
                  if (sdSPP) {
                    $shadeOptions
                      .find('.js-dropdown-option[data-sku-id=' + sku + ']')
                      .trigger('click');
                  } else {
                    $stdShadeSelect
                      .find('a.swatch[data-sku-base-id=' + skuBase + ']')
                      .trigger('click');
                  }
                  $('html, body').animate(
                    {
                      scrollTop: $sppPanel.offset().top
                    },
                    750,
                    'easeInOutQuad'
                  );
                }
              });
            }
          },

          selectParentWindowShade: function (evnt) {
            const $gridModalLink = $(evnt.target.parentElement);
            const frameArgs = {
              _elc_action: 'selectShade',
              skuBaseId: $gridModalLink.data('sku-id'),
              shadeName: $gridModalLink.attr('href').split('/shade/')?.[1]?.split('---')[0]
            };

            closeIcon.trigger('click');
            window.parentIFrame.sendMessage(frameArgs, '*');
            frameArgs['_elc_action'] = 'scrollIntoView';
            window.parentIFrame.sendMessage(frameArgs, '*');
          },

          // Initialise the setup of the filter(s).
          createFilters: function () {
            if (sppModelGridScope.config.sppModelGridDataList1 !== null) {
              sppModelGridScope.setupFilters(
                sppModelGridScope.config.sppModelGridDataList1,
                sppModelGridScope.config.sppModelGridDataLabel1
              );
            }
            if (sppModelGridScope.config.sppModelGridDataList2 !== null) {
              sppModelGridScope.setupFilters(
                sppModelGridScope.config.sppModelGridDataList2,
                sppModelGridScope.config.sppModelGridDataLabel2
              );
            }
          },

          // Filtering by class name - this sorts it for each tile.
          createClassFilters: function () {
            $.each(sppModelGridScope.els.sppModelGridItem, function () {
              var theFilters = $(this).data('filter-labels');
              var theClassFilters = theFilters
                .toString()
                .replace(/\s/g, '_')
                .replace(/[[\]']/g, ' ');

              $(this).addClass(theClassFilters);
            });
          },

          // Create a multi-filter array of tile layout vals.
          createMultiFilterTileNumArray: function () {
            $.each(sppModelGridScope.els.sppModelGridItem, function () {
              if ($(this)[0].hasAttribute('data-multi-filters')) {
                var multiFilterVal = $(this).data('multi-filters');

                multiFilterVal = multiFilterVal.substring(1, multiFilterVal.lastIndexOf(']'));
                var explodedString = multiFilterVal.split('-');

                sppModelGridScope.config.sppModelGridDataMultiFilterTileNums[
                  explodedString[0] + '-' + explodedString[1]
                ] = explodedString[2];
              }
            });
          },

          // Handle the hiding of tiles for content author-provided filter cases.
          tileFilterCases: function () {
            $.each(sppModelGridScope.els.sppModelGridItem, function () {
              if ($(this)[0].hasAttribute('data-hide-filters')) {
                var hideFilterVal = $(this).data('hide-filters');
                var actualFilterVal = hideFilterVal
                  .toString()
                  .replace(/\s/g, '_')
                  .replace(/,/g, '.')
                  .match(/[^[\]]+/g);

                $(this).attr('data-hide-filters', actualFilterVal);
              }
            });
          },

          // If the tile is to be hidden on landing.
          hideTileFilterCase: function () {
            var firstVal;
            var fixedValOne;
            var secondVal;
            var multiVal;

            if (sppModelGridScope.config.sppModelGridDataList1 !== null) {
              if (sppModelGridScope.config.sppModelGridDataList2 !== null) {
                firstVal = sppModelGridScope.config.sppModelGridDataList1[0];
                fixedValOne = firstVal.toString().replace(/\s/g, '_');
                secondVal = sppModelGridScope.config.sppModelGridDataList2[0];
                var fixedValTwo = secondVal.toString().replace(/\s/g, '_');

                multiVal = fixedValOne + '.' + fixedValTwo;
                var $tileToHide = $template.find(
                  '.js-sppmg:not(.hide)[data-hide-filters*="' + multiVal + '"]'
                );

                $tileToHide.addClass('spp_mg_grid_hide');
              } else {
                firstVal = sppModelGridScope.config.sppModelGridDataList1[0];
                fixedValOne = firstVal.toString().replace(/\s/g, '_');
                var $tileToHide = $template.find(
                  '.js-sppmg:not(.hide)[data-hide-filters*="' + fixedValOne + '"]'
                );

                $tileToHide.addClass('spp_mg_grid_hide');
              }
            }
          },

          // Handle a rare bug where an extra . is added before the classItems list.
          processChars: function (item) {
            if (item.charAt(0) === '.') {
              sppModelGridScope.func.sppModelGridProcessedVars = item.substring(1);
            } else {
              sppModelGridScope.func.sppModelGridProcessedVars = item;
            }
          },

          /* The main event for showing the tiles.
             IE Bug: Need to explicitly pass 'calc(100%/...' to prevent tile width issues. */
          tileEvents: function (classItems, targetFilter) {
            sppModelGridScope.processChars(classItems);
            var theTile = $(
              '.js-sppmg.' +
                sppModelGridScope.func.sppModelGridProcessedVars +
                ':not(.hide):not([data-hide-filters*="' +
                sppModelGridScope.func.sppModelGridProcessedVars +
                '"])'
            );

            theTile.addClass('font-size-' + targetFilter);
            sppModelGridScope.els.sppModelGridItem
              .parent()
              .removeClass(function (index, className) {
                return (className.match(/\bfilter-row-size-\S+/g) || []).join(' ');
              });
            theTile.parent().show();
            theTile.parent().addClass('filter-row-size-' + targetFilter);
            theTile
              .fadeIn()
              .promise()
              .done(function () {
                sppModelGridScope.func.sppModelGridFilterActive = false;
                sppModelGridScope.toggleAccordion(true);
              });
          },

          /* Filtering by the base tiles, i.e., if there's only one filter, or filtering by
             the first list item which shows all items at a certain tile value. */
          baseTilesToggle: function (classItems, filterIndex, filterIDIndex) {
            sppModelGridScope.els.sppModelGridItem
              .fadeOut()
              .promise()
              .done(function () {
                $(this).parent().hide();
                sppModelGridScope.removeFontClass();
                if (filterIndex === 1) {
                  sppModelGridScope.tileEvents(
                    classItems,
                    sppModelGridScope.config.sppModelGridDataTileNums1[filterIDIndex]
                  );
                } else if (filterIndex === 2) {
                  sppModelGridScope.tileEvents(
                    classItems,
                    sppModelGridScope.config.sppModelGridDataTileNums2[filterIDIndex]
                  );
                }
              });
          },

          // Handles if a tile is to be filtered by more than one value.
          multiFilterTilesToggle: function (classItems, filterIDIndex) {
            sppModelGridScope.els.sppModelGridItem
              .fadeOut()
              .promise()
              .done(function () {
                $(this).parent().hide();
                sppModelGridScope.removeFontClass();
                sppModelGridScope.tileEvents(classItems, filterIDIndex);
              });
          },

          // Handling the tile numbers when filtering by the first filter list item, i.e., 'All'
          manageFirstFilterListItem: function (
            filterIndex,
            selectedItems,
            filterIndexPos,
            currentIndex,
            classItems
          ) {
            var newFilterIndex;
            var newUpdatedfilterIndexPos;
            var filterIDIndex;
            var mainList;
            var otherList;
            var nullParentIndex;
            var updatedfilterIndexPos;

            if (filterIndex === 1) {
              newFilterIndex = 2;
              newUpdatedfilterIndexPos = selectedItems[1];
              nullParentIndex = 1;
              mainList = sppModelGridScope.config.sppModelGridDataList2;
              otherList = sppModelGridScope.config.sppModelGridDataList1;
            } else {
              newFilterIndex = 1;
              newUpdatedfilterIndexPos = selectedItems[0];
              nullParentIndex = 2;
              mainList = sppModelGridScope.config.sppModelGridDataList1;
              otherList = sppModelGridScope.config.sppModelGridDataList2;
            }
            if (currentIndex === 0) {
              filterIndex = newFilterIndex;
              updatedfilterIndexPos = newUpdatedfilterIndexPos;
              filterIDIndex = mainList.indexOf(updatedfilterIndexPos);
              if (filterIDIndex === -1) {
                filterIndex = nullParentIndex;
                updatedfilterIndexPos = filterIndexPos;
                filterIDIndex = otherList.indexOf(updatedfilterIndexPos);
              }
            } else {
              filterIDIndex = otherList.indexOf(filterIndexPos);
            }
            sppModelGridScope.baseTilesToggle(classItems, filterIndex, filterIDIndex);
          },

          filterItemClick: function () {
            var $this = $(this);
            var currentIndex = $(this)
              .closest('ul')
              .find('li:not(.sppmg__filterLabel)')
              .index($(this).parent());
            var filterIndex = $this.parent().parent().index() + 1;
            var filterID;
            var initArray = [];
            var classItems;
            var multiFilterItems;
            var selectedItems;
            var filterIndexPos;
            var filterIDIndex;

            if ($this.parent('li').hasClass('selected')) {
              sppModelGridScope.func.sppModelGridFilterActive = false;
            } else if (sppModelGridScope.func.sppModelGridFilterActive === false) {
              sppModelGridScope.updateDeactiveTileWidths();
              sppModelGridScope.func.sppModelGridFilterActive = true;
              $this.parent('li').addClass('selected').siblings().removeClass('selected');

              $('li.selected').each(function () {
                var data = $(this).find('.js-sppmg__filterItem').data('filter-id');

                initArray.push(data);
              });
              selectedItems = initArray.filter(function (n) {
                return n !== undefined;
              });
              classItems = selectedItems.join('.');
              multiFilterItems = selectedItems.join('-').replace('_', ' ');

              // If there's tiles with multi-filtering:
              if (sppModelGridScope.config.sppModelGridDataMultiFilterTileNums[multiFilterItems]) {
                filterIDIndex =
                  sppModelGridScope.config.sppModelGridDataMultiFilterTileNums[multiFilterItems];
                sppModelGridScope.multiFilterTilesToggle(classItems, filterIDIndex);
              } else {
                filterID = $this.data('filter-id');
                filterIndexPos = filterID.replace('_', ' ');

                // If there's multiple filters, but this tile doesn't have multi-filtering, or a filterable class:
                if ($('ul.js-sppmg__filter').length > 1) {
                  sppModelGridScope.manageFirstFilterListItem(
                    filterIndex,
                    selectedItems,
                    filterIndexPos,
                    currentIndex,
                    classItems
                  );
                } else {
                  // If there's one filter:
                  filterIDIndex =
                    sppModelGridScope.config.sppModelGridDataList1.indexOf(filterIndexPos);
                  sppModelGridScope.baseTilesToggle(classItems, filterIndex, filterIDIndex);
                }
              }
            }
            sppModelGridScope.toggleAccordion(true);
          },

          // The click event for the filter item.
          toggleFilters: function () {
            var sppModelGridFilterItem = $('.js-sppmg__filterItem');

            sppModelGridFilterItem.on('click', sppModelGridScope.filterItemClick);
          },

          showAccordionImages: function () {
            var $accordionImages = sppModelGridScope.els.sppModelGridMainImages;
            var container = sppModelGridScope.els.sppModelGridWrapper;
            var containerTop = container.offset().top;
            var containerMaxHeight = parseFloat(container.css('max-height'));

            $accordionImages.each(function () {
              var $img = $(this);

              // Skip already-loaded images
              if (!$img.data('src')) {
                return;
              }
              var imgTop = $img.offset().top - containerTop;
              var imgBottom = imgTop + $img.outerHeight();
              var isVisibleInContainer = imgBottom > 0 && imgTop < containerMaxHeight;

              if (isVisibleInContainer) {
                $img.attr('src', $img.data('src'));
                $img.removeData('src');
              }
            });
          },

          /* The function for the expand/collapse accordion item, only runs after
           * data has been populated so we can correctly count rows and height.
           * If a refresh occurs (e.g. changing filters, or resizing windows) then
           * classes and labels are left untouched, and heights are recalculated. */
          toggleAccordion: function (forceRefresh) {
            var isRefresh = forceRefresh === true ? true : false;
            var offset = 0.4;
            var $firstVisibleItem = sppModelGridScope.getFirstVisibleItem();
            var firstItemHeight = $firstVisibleItem.length ? $firstVisibleItem.outerHeight() : 0;
            var collapsedHeight =
              firstItemHeight * sppModelGridScope.config.sppModelGridDataAccordionRows +
              firstItemHeight * offset;
            var rowCount = sppModelGridScope.countVisibleRows(firstItemHeight);
            var containerScrollHeight = rowCount * firstItemHeight;
            /* Disable the button if the current filter/view has less than or equal to the defined
               row amount */

            sppModelGridScope.inactiveToggle();

            // Only add 'inactive' if we have valid measurements AND content fits
            if (
              firstItemHeight > 0 &&
              containerScrollHeight > 0 &&
              collapsedHeight >= containerScrollHeight
            ) {
              sppModelGridScope.els.sppModelGridAccordionToggle.addClass('inactive');
              isRefresh = true;
            } else {
              sppModelGridScope.els.sppModelGridAccordionToggle.removeClass('inactive');
            }

            var $toggle = sppModelGridScope.els.sppModelGridAccordionToggle;

            if (
              ($toggle.hasClass('collapsed') && !isRefresh) ||
              (!$toggle.hasClass('collapsed') && isRefresh)
            ) {
              if (!isRefresh) {
                $toggle
                  .text(sppModelGridScope.config.sppModelGridDataCollapseLabel)
                  .removeClass('collapsed');
              }
              sppModelGridScope.els.sppModelGridWrapper.css(
                'max-height',
                `${containerScrollHeight}px`
              );
            } else {
              // Run when the toggle is already Expanded.
              sppModelGridScope.els.sppModelGridWrapper.css(
                'max-height',
                firstItemHeight * sppModelGridScope.config.sppModelGridDataAccordionRows +
                  firstItemHeight * offset
              );
              if (!isRefresh) {
                // Only allow scroll after initial load complete.

                if (!$toggle.hasClass('hidden')) {
                  var $filter = sppModelGridScope.els.sppModelGridFilter;

                  if ($filter.length && sppModelGridScope.config.sppModelGridDataAccordionEnable) {
                    $('html, body').animate(
                      { scrollTop: $filter.offset().top - 100 },
                      600,
                      'easeInOutQuad'
                    );
                  }
                }
                $toggle.removeClass('hidden');
                $toggle
                  .text(sppModelGridScope.config.sppModelGridDataExpandLabel)
                  .addClass('collapsed');
              }
            }
            // Run again after animationDelay so max-height changes are applied
            setTimeout(function () {
              sppModelGridScope.showAccordionImages();
            }, animationDelay);
          },

          scheduleRefresh: function () {
            /* Debouncing to readjust the collapsed/expanded state if the tile
             * height changes due to a resize. */

            var debounceDelay = 150;

            clearTimeout(resizeTimerId);
            resizeTimerId = setTimeout(function () {
              var w = window.innerWidth;

              if (w !== lastWidth) {
                lastWidth = w;
                sppModelGridScope.toggleAccordion(true);
              }
            }, debounceDelay);
          },

          countVisibleRows: function (firstItemHeight) {

            /* Calculate container scroll height as number of flex rows * item height.
             * Originally we used scrollHeight of the container, however on iOS only
             * (both in chrome and safari) due to lazy-loading images, the containers of images
             * reported back at less than actual. This resulted in the max-height
             * being less than was needed on expansion. The fix was to use JS to iterate through
             * the visible items and calculate how many rows there are in the flex grid
             * and then multiply that by the height of the first onscreen item. An alternative
             * would have been to just to unset maxHeight, however this would have lost the gradual
             * animation of opening and closing the accordion and lost business approval. */
            var $visibleItems = sppModelGridScope.getAllVisibleItems();
            var rowCount = 0;
            if ($visibleItems.length && firstItemHeight > 0) {
              var uniqueRowPositions = {};
              var nodes = $visibleItems.get();
              for (var i = 0; i < nodes.length; i++) {
                var top = nodes[i].offsetTop;
                if (!uniqueRowPositions[top]) {
                  uniqueRowPositions[top] = true;
                  rowCount++;
                }
              }
            }
            else{
              // Default value from suggested in Drupal. Only used as a fallback here
              return 3
            }

            return rowCount;
          },

          /* Initialises click event for the expand/collapse accordion item and
           * determines the initial height state. Only runs after data
           * has been populated so we can correctly count rows and height. */
          initialiseAccordion: function () {
            sppModelGridScope.inactiveToggle();
            sppModelGridScope.els.sppModelGridAccordionToggle.addClass('hidden');

            sppModelGridScope.els.sppModelGridAccordionToggle.on('click', function (e) {
              if ($(this).hasClass('inactive')) {
                e.preventDefault();

                return;
              }
              sppModelGridScope.toggleAccordion();
            });

            // Temporarily replace all images to generate grid row heights for calculation
            sppModelGridScope.els.sppModelGridMainImages.each(function () {
              var $img = $(this);

              $img.data('src', $img.attr('src'));

              // Don't replace an image thats managed to preload already
              var imgEl = $img.get(0);

              if (!imgEl.complete) {
                $img.attr('src', 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=');
              }
            });

            /* Refresh the accordion once the first image loads and we 
               have a height to work with (Lazy-load protection) */
            var $firstVisibleItem = sppModelGridScope.getFirstVisibleItem();
            var $imgs = $firstVisibleItem.find('.js-sppmg__mainImg');

            $imgs.each(function () {
              var img = this;

              $(img).one('load', function () {
                sppModelGridScope.toggleAccordion(true);
              });
            });

            sppModelGridScope.toggleAccordion();
            $(window).on('resize orientationchange', sppModelGridScope.scheduleRefresh);
          },

          // Exit early if accordion is disabled
          inactiveToggle: function () {
            if (!sppModelGridScope.config.sppModelGridDataAccordionEnabled) {
              sppModelGridScope.els.sppModelGridAccordionToggle.addClass('inactive');
            }
          },

          getFirstVisibleItem: function () {
            return sppModelGridScope.els.sppModelGridItemNotInactive.filter(':visible').first();
          },

          getAllVisibleItems: function () {
            return sppModelGridScope.els.sppModelGridItemNotInactive.filter(':visible');
          },

          /* CAROUSEL FUNCTIONALITY.
             Grab the slides from the content-blocks
             and append them to the carousel. */
          grabSlides: function () {
            $.each(sppModelGridScope.els.sppModelGridItemNotInactive, function () {
              $(this).find('.js-sppmg__slide').detach().appendTo(innerCarousel);
            });
            carousel.find('.js-sppmg__slideHolder').last().detach().appendTo(innerCarousel);
          },

          // Update the slide content with the general product name, price etc.
          updateCarouselSlideContent: function () {
            $.each(innerCarousel.children('.js-sppmg__slide'), function () {
              $(this)
                .find(sppModelGridScope.els.sppModelGridProdTitle)
                .html(sppModelGridScope.config.sppModelGridDataProd1);
              $(this)
                .find(sppModelGridScope.els.sppModelGridProdSubtitle)
                .html(sppModelGridScope.config.sppModelGridDataProd2);
              $(this)
                .find(sppModelGridScope.els.sppModelGridProdPrice)
                .html(sppModelGridScope.config.sppModelGridDataPrice);
              $(this)
                .find(sppModelGridScope.els.sppModelGridSlideDetailsInner)
                .html(sppModelGridScope.config.sppModelGridDataViewDetails);
              $(this)
                .find(sppModelGridScope.els.sppModelGridSlideBtn)
                .attr('data-product-id', sppModelGridScope.config.sppModelGridDataProdId);
              $(this)
                .find(sppModelGridScope.els.sppModelGridSlideBtn)
                .html(sppModelGridScope.config.sppModelGridDataBtnCopy);
              $(this)
                .find(sppModelGridScope.els.sppModelGridHoverSold)
                .html(sppModelGridScope.config.sppModelGridDataSoldOut);
            });
            // Populate each tile rollover link copy.
            $.each(sppModelGridScope.els.sppModelGridHover, function () {
              $(this)
                .find(sppModelGridScope.els.sppModelGridHoverShop)
                .html(sppModelGridScope.config.sppModelGridDataShopNow);
              $(this)
                .find(sppModelGridScope.els.sppModelGridHoverSold)
                .html(sppModelGridScope.config.sppModelGridDataSoldOut);
            });
          },

          // Remove extraneous node wrappers.
          removeNodeWrappers: function () {
            var extraElements = $template.find(
              '.node.node-elc-nodeblock, .content, div:not([class])'
            );

            extraElements.contents().unwrap();
          },

          //  Strip any whitespace to prevent spaces between slides.
          stripSlideWhitespace: function () {
            var stripWhiteSpace = carousel.find('*');

            stripWhiteSpace
              .contents()
              .filter(function () {
                return (this.nodeType = Node.TEXT_NODE && /\S/.test(this.nodeValue) === false);
              })
              .remove();
          },

          /* Calculate the number of inner slides.
             Set the width of the carousel wrapper and inner container.
             IE Bug: Need to explicitly pass 'calc(100%/...' to prevent tile width issues. */
          widthCalcs: function () {
            slideTotal = innerCarousel.children().length - 2;
            carouselWrapper.css('width', slideTotal * 100 + '%');
            innerCarousel.css('width', 'calc(100%/' + slideTotal + ')');
          },

          // Add identifying classes to the slides.
          addSlideClasses: function () {
            $.each(innerCarousel.children().not('.js-sppmg__slideHolder'), function (i) {
              $(this).addClass('js-spp_mg_slide_' + (i + 1));
            });
          },

          // Handle the placeholder slides.
          handlePlaceholderSlides: function () {
            firstSlide = carousel.find('.js-spp_mg_grid_item_slideFirst').html();
            lastSlide = carousel.find('.js-spp_mg_grid_item_slideLast').html();
            carousel.find('.js-sppmg__slideHolder').last().append(firstSlide);
            carousel.find('.js-sppmg__slideHolder').first().append(lastSlide);
            carousel.find('.js-spp_mg_grid_item_slideFirst').addClass('active');
          },

          // Only update the image in the carousel when asked for on opening the pop up.
          updateImageSources: function ($active) {
            var $activeSlideMainImg = $active.find('.js-model-image-main');
            var $swatch = $active.find('.js-swatch-image');

            if (!$activeSlideMainImg.hasClass('image-init')) {
              $activeSlideMainImg
                .find('img')
                .attr('src', $activeSlideMainImg.data('model-main-image'));
              $activeSlideMainImg.addClass('image-init');
              $swatch.find('img').attr('src', $swatch.data('model-swatch-image'));
            }
          },

          // Handle active classes.
          addActive: function (index) {
            var $active = carousel.find('.js-sppmg__slide').eq(index);

            $active.addClass('active').siblings().removeClass('active');
            sppModelGridScope.updateImageSources($active);
          },

          nextSlideActive: function () {
            var $nextSlide = carousel.find('.js-sppmg__slide.active').next();

            $nextSlide.addClass('active').siblings().removeClass('active');
            sppModelGridScope.updateImageSources($nextSlide);
          },

          prevSlideActive: function () {
            var $prevSlide = carousel.find('.js-sppmg__slide.active').prev();

            $prevSlide.addClass('active').siblings().removeClass('active');
            sppModelGridScope.updateImageSources($prevSlide);
          },

          switchActive: function (a) {
            if (a === 'First') {
              var $lastSlide = carousel.find('.js-spp_mg_grid_item_slideLast');

              if ($lastSlide.length > 0) {
                $lastSlide.addClass('active').siblings().removeClass('active');
                sppModelGridScope.updateImageSources($lastSlide);
              }
            } else if (a === 'Last') {
              var $firstSlide = carousel.find('.js-spp_mg_slide_1');

              if ($firstSlide.length > 0) {
                $firstSlide.addClass('active').siblings().removeClass('active');
                sppModelGridScope.updateImageSources($firstSlide);
              }
            }
          },

          // Check for RTL
          checkRTL: function () {
            setTimeout(function () {
              if ($('html[dir="rtl"]').length) {
                isRTL = true;
              } else {
              }
            }, 1000);
          },

          // Determine direction (RTL support)
          negativeDirection: function () {
            theDirection = '-=100%';
            counter--;
            goingRight = true;
            goingLeft = false;
          },

          positiveDirection: function () {
            theDirection = '+=100%';
            counter++;
            goingRight = false;
            goingLeft = true;
          },

          // Navigating the carousel.
          animateCarousel: function (arrowNo) {
            slideTotal = innerCarousel.children().length - 2;
            marginResetLeft = -(slideTotal * 100) + '%';
            marginResetRight = -100 + '%';
            counterRight = 0;
            counterLeft = -(slideTotal - 1);
            carousel.find('.js-sppmg__carouselNav--' + arrowNo).click(function () {
              if (isAnimating === false) {
                isAnimating = true;
                if (arrowNo === 1) {
                  if (isRTL) {
                    sppModelGridScope.negativeDirection();
                  } else {
                    sppModelGridScope.positiveDirection();
                  }
                } else if (isRTL) {
                  sppModelGridScope.positiveDirection();
                } else {
                  sppModelGridScope.negativeDirection();
                }
                carouselWrapper.animate(
                  {
                    marginLeft: theDirection
                  },
                  600,
                  'easeInOutQuad',
                  function () {
                    if (goingRight) {
                      sppModelGridScope.nextSlideActive();
                    } else if (goingLeft) {
                      sppModelGridScope.prevSlideActive();
                    }
                    if (counter === -slideTotal) {
                      carouselWrapper.css({
                        'margin-left': marginResetRight
                      });
                      counter = counterRight;
                      sppModelGridScope.switchActive('Last', 'First');
                    } else if (counter === 1) {
                      carouselWrapper.css({
                        'margin-left': marginResetLeft
                      });
                      counter = counterLeft;
                      sppModelGridScope.switchActive('First', 'Last');
                    }
                    isAnimating = false;
                  }
                );
              }
            });
          },

          // Open the carousel from a tile.
          openCarouselModal: function () {
            $.each(sppModelGridScope.els.sppModelGridItemNotInactive, function (index) {
              /* Set the slide and counter value according
                 to the tile number clicked. */
              $(this).on('click', function () {
                counter = -index;
                sppModelGridScope.addActive(index + 1);
                tileMargin = counter * 100 - 100 + '%';
                carouselWrapper.css({
                  'margin-left': tileMargin
                });

                if (window.parentIFrame) {
                  const frameArgs = {
                    _elc_action: 'scrollIntoView',
                    scrollTarget: `#${window.parentIFrame.getId()}`
                  };

                  $template.css('min-height', '1200px');
                  window.parentIFrame.sendMessage(frameArgs, '*');
                }

                // Hide the Popup in PC, when the SKU out of stock
                if (!$(this).hasClass('sppmg__outStock') || sppModelGridScope.isMobile()) {
                  sppModelGridContents.siblings(carousel).fadeIn();
                  sppModelGridModalBg.fadeIn();
                  $('html, body').animate(
                    {
                      scrollTop: $('.sppmg__carouselContainer', context).offset().top - 170
                    },
                    'slow'
                  );
                }
              });
            });
          },

          // Close the carousel.
          closeCarouselModal: function () {
            closeIcon.on('click', function () {
              $template.css('min-height', 'unset');
              $(this).closest(carousel).fadeOut();
              sppModelGridModalBg.fadeOut();
            });
          },

          // Close the carousel clicking anywhere but the modal.
          closeCarouselModalAnywhere: function () {
            sppModelGridModalBg.on('click', function () {
              closeIcon.trigger('click');
            });
          },

          // Mobile swipe of carousel.
          swipeCarousel: function () {
            if ($(window).width() < 768) {
              carousel.find(carouselWrapper).swiperight(function () {
                carousel.find('.js-sppmg__carouselNav--1').trigger('click');
              });
              carousel.find(carouselWrapper).swipeleft(function () {
                carousel.find('.js-sppmg__carouselNav--2').trigger('click');
              });
            }
          }
        };

        sppModelGridScope.init();
        window.onload = function () {
          sppModelGridScope.filterItemClick.call(
            $('.js-sppmg__filter').eq(1).find('.js-sppmg__filterItem').eq(0)
          );
          $template
            .find('.js-sppmg__filter')
            .eq(2)
            .find('.js-sppmg__filterItem')
            .eq(0)
            .parent('li')
            .addClass('selected');
          sppModelGridScope.deepLink();
        };
      });
    }
  };
})(jQuery);
